module.exports = __webpack_public_path__ + "static/img/首页入口.e2ea518.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/首页入口.gif
// module id = 5DKe
// module chunks = 3